
      var _image, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgConfettiMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 304,
  height: 134,
  textRendering: "geometricPrecision",
  viewBox: "0 0 304 134"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "ConfettiMobile_5577d34aaab6c43c__a",
  width: 304,
  height: 134,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAAElBMVEVMaXH////////////////////7e1ULAAAABXRSTlMA34NWuQFz+10AAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADASURBVHja7dtJCoAwEEXBjtr3v7IBd678QkCh6giPdkxSBQDwR/vQIDK6NxWCAevp0CEZsGnsSjy09VVMiWzGTFg2ZAYsfLMwYAAAAAAAANRH1kft8ahwCV6xxGHHwosZs6Rc0Qq8y/LFxhgzll2WbmNhMQkAYOmj1rtJelhDsfR7QbH4cIsQUa8WIuvlE76e/4b0kyg+a6aXXitvYM7LegVbWUyv8DEpAQAAAAAAAAAAAAAAAAAAAAAAAAAAwM0JYt8CLhFv9GYAAAAASUVORK5CYII=",
  width: 304,
  height: 134,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAAElBMVEVMaXH////////////////////7e1ULAAAABXRSTlMA34NWuQFz+10AAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADASURBVHja7dtJCoAwEEXBjtr3v7IBd678QkCh6giPdkxSBQDwR/vQIDK6NxWCAevp0CEZsGnsSjy09VVMiWzGTFg2ZAYsfLMwYAAAAAAAANRH1kft8ahwCV6xxGHHwosZs6Rc0Qq8y/LFxhgzll2WbmNhMQkAYOmj1rtJelhDsfR7QbH4cIsQUa8WIuvlE76e/4b0kyg+a6aXXitvYM7LegVbWUyv8DEpAQAAAAAAAAAAAAAAAAAAAAAAAAAAwM0JYt8CLhFv9GYAAAAASUVORK5CYII=",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
})), /*#__PURE__*/React.createElement("mask", {
  id: "ConfettiMobile_5577d34aaab6c43c__b",
  width: 304,
  height: 134,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAADFBMVEVMaXH///////////8/u4fCAAAAA3RSTlMA44BinefRAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAeklEQVR42u3csQ3AQAgEwefpv2fXcJFP9kwFaIUIOQcAAPinGQ2iXrurQhhsrw5hMRmyYjbM2QcAAAAAAAAAAAAAAAAAAAAAAKDDeA6WvlMTISzmn9onik3v5m9nsd5bcTtHK/5VWTqY2woAAAAAAAAAAAAAAAAAwNseGL0AbNCsuQgAAAAASUVORK5CYII=",
  width: 304,
  height: 134,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAADFBMVEVMaXH///////////8/u4fCAAAAA3RSTlMA44BinefRAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAeklEQVR42u3csQ3AQAgEwefpv2fXcJFP9kwFaIUIOQcAAPinGQ2iXrurQhhsrw5hMRmyYjbM2QcAAAAAAAAAAAAAAAAAAAAAAKDDeA6WvlMTISzmn9onik3v5m9nsd5bcTtHK/5VWTqY2woAAAAAAAAAAAAAAAAAwNseGL0AbNCsuQgAAAAASUVORK5CYII=",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAAG1BMVEVMaXG0cP2+h/3m0/jt4fvz6/z///////////+2kJb/AAAACHRSTlMAIRA5UKzTcJC19KMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAD1SURBVHja7dxJEoMgEAVQFBDvf+LoMqks6FQGiO+dQH91yxBCSgAAc1pEwKOcFVnw/Yqkgm9Z9Fl/Q+rGlxJ7U26rmQCfTuwKRbYoMgCAQbStNivygLIfJBaY+5+BNTn0LwjPwKoc+gksaDsC28TQrwosHtguhsBE7AzMNllgmCytblkOYNMdJvnhUFuCExAzz73TRQ7HqDIAMNZKDMt4tfWVvOTmBD3gA8aTIVJuscRMKGJdKS8AAACAZK81uYKO+/pyPUD6h53pvAzck2M+26j/wi9jfvnr0ONR8UjTD5VrTW7GAAAAAAAAAAAAAAAAAADgx250EAHpHd5SxQAAAABJRU5ErkJggg==",
  width: 304,
  height: 134,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAAG1BMVEVMaXG0cP2+h/3m0/jt4fvz6/z///////////+2kJb/AAAACHRSTlMAIRA5UKzTcJC19KMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAD1SURBVHja7dxJEoMgEAVQFBDvf+LoMqks6FQGiO+dQH91yxBCSgAAc1pEwKOcFVnw/Yqkgm9Z9Fl/Q+rGlxJ7U26rmQCfTuwKRbYoMgCAQbStNivygLIfJBaY+5+BNTn0LwjPwKoc+gksaDsC28TQrwosHtguhsBE7AzMNllgmCytblkOYNMdJvnhUFuCExAzz73TRQ7HqDIAMNZKDMt4tfWVvOTmBD3gA8aTIVJuscRMKGJdKS8AAACAZK81uYKO+/pyPUD6h53pvAzck2M+26j/wi9jfvnr0ONR8UjTD5VrTW7GAAAAAAAAAAAAAAAAAADgx250EAHpHd5SxQAAAABJRU5ErkJggg==",
  preserveAspectRatio: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  shapeRendering: "crispEdges"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#ConfettiMobile_5577d34aaab6c43c__a)",
  d: "M0 0h304v134H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-bright,#c5a0ef)",
  mask: "url(#ConfettiMobile_5577d34aaab6c43c__b)",
  d: "M0 0h304v134H0z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"304\" height=\"134\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 304 134\"><defs><mask id=\"layer-0\" width=\"304\" height=\"134\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAAElBMVEVMaXH////////////////////7e1ULAAAABXRSTlMA34NWuQFz+10AAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADASURBVHja7dtJCoAwEEXBjtr3v7IBd678QkCh6giPdkxSBQDwR/vQIDK6NxWCAevp0CEZsGnsSjy09VVMiWzGTFg2ZAYsfLMwYAAAAAAAANRH1kft8ahwCV6xxGHHwosZs6Rc0Qq8y/LFxhgzll2WbmNhMQkAYOmj1rtJelhDsfR7QbH4cIsQUa8WIuvlE76e/4b0kyg+a6aXXitvYM7LegVbWUyv8DEpAQAAAAAAAAAAAAAAAAAAAAAAAAAAwM0JYt8CLhFv9GYAAAAASUVORK5CYII=\" width=\"304\" height=\"134\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAAElBMVEVMaXH////////////////////7e1ULAAAABXRSTlMA34NWuQFz+10AAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADASURBVHja7dtJCoAwEEXBjtr3v7IBd678QkCh6giPdkxSBQDwR/vQIDK6NxWCAevp0CEZsGnsSjy09VVMiWzGTFg2ZAYsfLMwYAAAAAAAANRH1kft8ahwCV6xxGHHwosZs6Rc0Qq8y/LFxhgzll2WbmNhMQkAYOmj1rtJelhDsfR7QbH4cIsQUa8WIuvlE76e/4b0kyg+a6aXXitvYM7LegVbWUyv8DEpAQAAAAAAAAAAAAAAAAAAAAAAAAAAwM0JYt8CLhFv9GYAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask><mask id=\"layer-1\" width=\"304\" height=\"134\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAADFBMVEVMaXH///////////8/u4fCAAAAA3RSTlMA44BinefRAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAeklEQVR42u3csQ3AQAgEwefpv2fXcJFP9kwFaIUIOQcAAPinGQ2iXrurQhhsrw5hMRmyYjbM2QcAAAAAAAAAAAAAAAAAAAAAAKDDeA6WvlMTISzmn9onik3v5m9nsd5bcTtHK/5VWTqY2woAAAAAAAAAAAAAAAAAwNseGL0AbNCsuQgAAAAASUVORK5CYII=\" width=\"304\" height=\"134\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAADFBMVEVMaXH///////////8/u4fCAAAAA3RSTlMA44BinefRAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAeklEQVR42u3csQ3AQAgEwefpv2fXcJFP9kwFaIUIOQcAAPinGQ2iXrurQhhsrw5hMRmyYjbM2QcAAAAAAAAAAAAAAAAAAAAAAKDDeA6WvlMTISzmn9onik3v5m9nsd5bcTtHK/5VWTqY2woAAAAAAAAAAAAAAAAAwNseGL0AbNCsuQgAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask></defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAAG1BMVEVMaXG0cP2+h/3m0/jt4fvz6/z///////////+2kJb/AAAACHRSTlMAIRA5UKzTcJC19KMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAD1SURBVHja7dxJEoMgEAVQFBDvf+LoMqks6FQGiO+dQH91yxBCSgAAc1pEwKOcFVnw/Yqkgm9Z9Fl/Q+rGlxJ7U26rmQCfTuwKRbYoMgCAQbStNivygLIfJBaY+5+BNTn0LwjPwKoc+gksaDsC28TQrwosHtguhsBE7AzMNllgmCytblkOYNMdJvnhUFuCExAzz73TRQ7HqDIAMNZKDMt4tfWVvOTmBD3gA8aTIVJuscRMKGJdKS8AAACAZK81uYKO+/pyPUD6h53pvAzck2M+26j/wi9jfvnr0ONR8UjTD5VrTW7GAAAAAAAAAAAAAAAAAADgx250EAHpHd5SxQAAAABJRU5ErkJggg==\" id=\"convert2-underlay\" width=\"304\" height=\"134\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACGCAMAAABtwSYdAAAAG1BMVEVMaXG0cP2+h/3m0/jt4fvz6/z///////////+2kJb/AAAACHRSTlMAIRA5UKzTcJC19KMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAD1SURBVHja7dxJEoMgEAVQFBDvf+LoMqks6FQGiO+dQH91yxBCSgAAc1pEwKOcFVnw/Yqkgm9Z9Fl/Q+rGlxJ7U26rmQCfTuwKRbYoMgCAQbStNivygLIfJBaY+5+BNTn0LwjPwKoc+gksaDsC28TQrwosHtguhsBE7AzMNllgmCytblkOYNMdJvnhUFuCExAzz73TRQ7HqDIAMNZKDMt4tfWVvOTmBD3gA8aTIVJuscRMKGJdKS8AAACAZK81uYKO+/pyPUD6h53pvAzck2M+26j/wi9jfvnr0ONR8UjTD5VrTW7GAAAAAAAAAAAAAAAAAADgx250EAHpHd5SxQAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\"/><g shape-rendering=\"crispEdges\"><rect width=\"304\" height=\"134\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\"/><rect width=\"304\" height=\"134\" fill=\"var(--theme-bright,#c5a0ef)\" mask=\"url(#layer-1)\"/></g></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/ConfettiMobile.5577d34aaab6c43c51f430e8b211a284.svg"),
        {
          React: SvgConfettiMobile,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      